import { HttpContextToken } from '@angular/common/http';

export const IS_UNCANCELABLE_REQUEST = new HttpContextToken<boolean>(() => false);
